/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * 
 * @export
 * @enum {string}
 */
export enum FxIdDomainSettingsPublicWebClientConfigOptionsDiagType {
    PortCheck = 1,
    Ping = 2,
    TraceRoute = 3,
    MSInfo = 4,
    DXDiag = 5,
    ProcessList = 6,
    File = 7,
    NUMBER_unknown_default_open_api = 11184809
}


export function instanceOfFxIdDomainSettingsPublicWebClientConfigOptionsDiagType(value: any): boolean {
    for (const key in FxIdDomainSettingsPublicWebClientConfigOptionsDiagType) {
        if (Object.prototype.hasOwnProperty.call(FxIdDomainSettingsPublicWebClientConfigOptionsDiagType, key)) {
            if (FxIdDomainSettingsPublicWebClientConfigOptionsDiagType[key as keyof typeof FxIdDomainSettingsPublicWebClientConfigOptionsDiagType] === value) {
                return true;
            }
        }
    }
    return false;
}

export function FxIdDomainSettingsPublicWebClientConfigOptionsDiagTypeFromJSON(json: any): FxIdDomainSettingsPublicWebClientConfigOptionsDiagType {
    return FxIdDomainSettingsPublicWebClientConfigOptionsDiagTypeFromJSONTyped(json, false);
}

export function FxIdDomainSettingsPublicWebClientConfigOptionsDiagTypeFromJSONTyped(json: any, ignoreDiscriminator: boolean): FxIdDomainSettingsPublicWebClientConfigOptionsDiagType {
    return json as FxIdDomainSettingsPublicWebClientConfigOptionsDiagType;
}

export function FxIdDomainSettingsPublicWebClientConfigOptionsDiagTypeToJSON(value?: FxIdDomainSettingsPublicWebClientConfigOptionsDiagType | null): any {
    return value as any;
}

export function FxIdDomainSettingsPublicWebClientConfigOptionsDiagTypeToJSONTyped(value: any, ignoreDiscriminator: boolean): FxIdDomainSettingsPublicWebClientConfigOptionsDiagType {
    return value as FxIdDomainSettingsPublicWebClientConfigOptionsDiagType;
}

